import React from 'react';
import { PropertyType as SrsPropertyType } from 'srs-middleware';
import { EndpointPropertyArraySelector } from 'components/selectors/endpointPropertyArraySelector';

export const ChoroplethMapKnobs = ({ cardIndex, endpointQuery }) => {
	return (
		<React.Fragment>
			<EndpointPropertyArraySelector
				cardIndex={cardIndex}
				types={[SrsPropertyType.GeoPoint]}
				label={'Geometry Property'}
				endpointQuery={endpointQuery}
				cy-test="feature-property-dropdown-button"
				optionsKey={'propertyList'}
				isNullable={false}
			/>
			<EndpointPropertyArraySelector
				cardIndex={cardIndex}
				itemIndex={0}
				types={[SrsPropertyType.Numeric]}
				label={'Feature Property'}
				endpointQuery={endpointQuery}
				cy-test="feature-property-dropdown-button"
				propertyName={'metadataPropertyNames'}
				isNullable={true}
			/>
		</React.Fragment>
	);
};
